import React from 'react';
import { cn } from '../../lib/utils';

export const Input = React.forwardRef(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={cn(
      'h-11 w-full rounded-xl border border-border bg-background px-3.5 text-sm text-foreground',
      'placeholder:text-muted-foreground transition-colors',
      'focus:border-primary/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40',
      className
    )}
    {...props}
  />
));
Input.displayName = 'Input';

export function Label({ className, ...props }) {
  return (
    <label
      className={cn('mb-1.5 block text-sm font-medium text-foreground', className)}
      {...props}
    />
  );
}
